/*
* routes.js
*
* Description: Holds common/global Routes for Module::'Flights'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Flights"
* Copyright 2018,2019,2020,2021 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import Router from 'vue-router';
import { store } from './stores/store';

Vue.use(Router);


export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        // >>> ----------------------------------------------------------------- '/'
        {
            path: '/',
            component: () => import('@/views/dashboard/Index'),
            props: true,
            children: [
                {
                    name: 'Dashboard',
                    path: '',
                    component: () => import('@/views/dashboard/Dashboard'),
                    beforeEnter(to, from, next) {
                        if (store.state.shared.idUser) {
                            next();
                        } else {
                            next('/pages/login');
                        }
                    }
                }
            ]
        },

        // >>> ----------------------------------------------------------------- '/flights'
        {
            path: '/flights',
            component: () => import('@/views/flights/Index'),
            children: [
                {
                    name: 'Flights',
                    path: 'flights',
                    component: () => import('@/views/flights/flights/Home'),
                    beforeEnter(to, from, next) {

                        store.state.shared.shared_Path = to.name;

                        if (store.state.shared.idUser) {
                            if (store.getters.get_Shared_isUserAllowedToUse('ANYTHING')) {
                                next();
                                if (!Vue.prototype.$isDesktop()) {
                                    store.dispatch('actn_set_Drawer', false);
                                }
                            }
                        } else {
                            next('/pages/login');
                        }
                    }
                }, // eo function beforeEnter()
                {
                    name: 'Blocktimes',
                    path: 'blocktimes',
                    component: () => import('@/views/flights/blocktimes/Home'),
                    beforeEnter(to, from, next) {

                        store.state.shared.shared_Path = to.name;

                        if (store.state.shared.idUser) {
                            if (store.getters.get_Shared_isUserAllowedToUse('ANYTHING') && Vue.prototype.$isDesktop()) {
                                next();
                            }
                        } else {
                            next('/pages/login');
                        }
                    } // eo function beforeEnter()
                },
                {
                    name: 'Airports',
                    path: 'airports',
                    component: () => import('@/views/flights/airports/Home'),
                    beforeEnter(to, from, next) {

                        store.state.shared.shared_Path = to.name;

                        if (store.state.shared.idUser) {
                            if (store.getters.get_Shared_isUserAllowedToUse('ANYTHING') && Vue.prototype.$isDesktop()) {
                                next();
                            }
                        } else {
                            next('/pages/login');
                        }
                    } // eo function beforeEnter()
                },
                {
                    name: 'Slotmanagement',
                    path: 'slotmanagement',
                    component: () => import('@/views/flights/slotmanagement/Home'),
                    props: true,
                    beforeEnter(to, from, next) {

                        store.state.shared.shared_Path = to.name;

                        if (store.state.shared.idUser) {
                            if (!store.getters.get_Shared_isUserAllowedToUse('READONLY') && store.getters.get_Shared_isUserAllowedToUse('ADMIN') && Vue.prototype.$isDesktop()) {
                                next();
                            }
                        } else {
                            next('/pages/login');
                        }
                    } // eo function beforeEnter()
                }
            ]
        },

        // >>> ----------------------------------------------------------------- '/pages'
        {
            path: '/pages',
            component: () => import('@/views/pages/Index'),
            children: [
                {
                    name: 'Lock',
                    path: 'lock',
                    component: () => import('@/views/pages/Lock')
                },
                {
                    name: 'Login',
                    path: 'login',
                    component: () => import('@/views/pages/Login')
                }
            ]
        },

        // >>> ----------------------------------------------------------------- '404'
        {
            path: '*',
            component: () => import('@/views/pages/Index'),
            children: [
                {
                    name: '404 Error',
                    path: '',
                    component: () => import('@/views/pages/Error')
                }
            ]
        }
    ]
});
